import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType, TierUnit, CargoQuantityUnit, TimeUnit } from "__generated__/graphql";
import { PayableOver } from "__generated__/enums";

export const FreightSchema: RegistryItem = {
	[AgreementTypeEnum.Freight]: {
		defaultValues: {
			calculationMethod: {
				type: null,
				tierUnit: TierUnit.CargoQuantity,
				cargoQuantityUnit: CargoQuantityUnit.Mton,
				timeUnit: TimeUnit.DayProRata,
				payableOver: PayableOver.Actual,
			},
		},
		agreementFields: {
			"agreement.costType": { rules: { hidden: true } },
			"agreement.description": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.tierUnit": { rules: { hidden: true } },
			"calculationMethod.cargoQuantityUnit": { rules: { hidden: true } },
			"calculationMethod.price": {
				path: "calculationMethod.price",
				rules: { requiredIf: ({ calculationMethodType }) => calculationMethodType === CalculationMethodType.CargoQuantity },
			},
		},
	},
};
